import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import RelatorioCalibracaoPrensaPrint from "./RelatorioCalibracaoPrensaPrint";
import { abrirJanelaImpressao } from "./impressaoCalibracaoPrensa";
import { FormControlLabel, Checkbox, Radio, RadioGroup } from "@mui/material";
import { useParams } from "react-router-dom";

import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack
} from "@mui/material";

import "./CalibracaoPrensa.css";
import Autocomplete from "@mui/material/Autocomplete";
import { db } from "../Config/firebase";
import { 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  where, 
  orderBy,
  doc,
  getDoc,
  updateDoc
} from "firebase/firestore";
import Navbar from "../Components/Navbar/navbar";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import { gerarSequencial } from "../Utils/sequencial";
import { aplicarTenantAtual, consultaTenantAtual } from "../Utils/tenant";


export default function CalibracaoPrensa() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
const [obras, setObras] = useState([]);
const [equipamentosPadrao, setEquipamentosPadrao] = useState([]);
const [equipamentoPadraoSelecionado, setEquipamentoPadraoSelecionado] = useState(null);
const [obraSelecionada, setObraSelecionada] = useState(null);
const [pesquisaObra, setPesquisaObra] = useState("");
const [pesquisaEquipamentoPadrao, setPesquisaEquipamentoPadrao] = useState("");
const history = useHistory();
const { id } = useParams();
const location = useLocation();
const clonarId = id === "novo" ? new URLSearchParams(location.search).get("clonar") : null;


useEffect(() => {
  carregarObras();
  carregarEquipamentosPadrao();
  carregarCalibracao();
}, [id, clonarId]);

function recalcularResultados(valorDivisaoAtual) {

  const lista = resultados.map(item => {

    const v1 = item.l1;
const v2 = item.l2;
const v3 = item.l3;

if (
  v1 === "-" || v2 === "-" || v3 === "-" ||
  v1 === "" || v2 === "" || v3 === ""
) {
  return {
    ...item,
    mediaKgf: "-",
    mediaKn: "-",
    erro: "-",
    resolucao: "-",
    repet: "-",
    classe: "-"
  };
}

const a = parseFloat(v1);
const b = parseFloat(v2);
const c = parseFloat(v3);

if (!isNaN(a) && !isNaN(b) && !isNaN(c)) {

      const media = (a + b + c) / 3;

      const mediaKn = media * 0.0098065;

      const erro = ((media - item.kgf) / item.kgf) * 100;   

      const divisao = parseFloat(
  String(valorDivisaoAtual).replace(",", ".")
);

let resolucao = 0;

if (!isNaN(divisao) && mediaKn !== 0) {
  resolucao = (divisao / mediaKn) * 100;
}

      const max = Math.max(a, b, c);
      const min = Math.min(a, b, c);
      const repet = ((max - min) / media) * 100;

      const erroAbs = Math.abs(erro);
const resolucaoNum = resolucao;

// transforma em 0 ou 1 (igual Excel)
const c05 = [
  erroAbs <= 0.5 ? 1 : 0,
  repet <= 0.5 ? 1 : 0,
  resolucaoNum <= 0.25 ? 1 : 0,
  1 // (no Excel sempre tem 4 colunas)
];

const c1 = [
  erroAbs <= 1 ? 1 : 0,
  repet <= 1 ? 1 : 0,
  resolucaoNum <= 0.5 ? 1 : 0,
  1
];

const c2 = [
  erroAbs <= 2 ? 1 : 0,
  repet <= 2 ? 1 : 0,
  resolucaoNum <= 1 ? 1 : 0,
  1
];

const c3 = [
  erroAbs <= 3 ? 1 : 0,
  repet <= 3 ? 1 : 0,
  resolucaoNum <= 1.5 ? 1 : 0,
  1
];

// soma igual Excel
const soma = arr => arr.reduce((t, v) => t + v, 0);

let classe = "-";

if (soma(c05) === 4) classe = "0,5";
else if (soma(c1) === 4) classe = "1,0";
else if (soma(c2) === 4) classe = "2,0";
else if (soma(c3) === 4) classe = "3,0";

      return {
  ...item,
  mediaKgf: media.toFixed(0),
  mediaKn: mediaKn.toFixed(2),
  erro: erro.toFixed(2),
  resolucao: resolucao.toFixed(2),
  repet: repet.toFixed(2),
  classe
};
    }

    return item;
  });

  setResultados(lista);
  
}
async function carregarCalibracao() {

  if ((!id || id === "novo") && !clonarId) return;

  const ref = doc(db, "tblCalibracaoPrensas", clonarId || id);
  const snap = await getDoc(ref);

  if (!snap.exists()) return;

  const dados = snap.data();

  const dadosFormulario = {
    ...dados,
    escala: dados.escala || montarEscalaCalibracao(dados.capacidade),
    dataVencimento:
      dados.dataVencimento ||
      calcularDataVencimentoISO(dados.dataCalibracao || dados.data, dados.validade)
  };

  setForm(clonarId ? {
    ...Object.fromEntries(Object.keys(estadoInicial).map((campo) => [campo, dadosFormulario[campo] ?? estadoInicial[campo]])),
    obraId: dados.obraId || "",
    codigo: "",
    certificado: "",
    data: "",
    dataCalibracao: "",
    dataVencimento: "",
    classe: dadosFormulario.classe || "",
    ativo: true,
  } : dadosFormulario);

  if (clonarId) {
    // Ao clonar, volta ao modo automático para recalcular a classe
    // conforme os resultados/equipamento clonados.
    setClasseEditadaManualmente(false);
    setClasseGeral("");
  } else {
    // Em registros antigos, o campo ainda não existia e portanto
    // a classe continua automática. Nos novos, respeita a edição manual.
    const classeFoiEditadaManualmente = dados.classeEditadaManualmente === true;

    setClasseEditadaManualmente(classeFoiEditadaManualmente);
    setClasseGeral(dadosFormulario.classe || "");
  }

  if (dados.resultados) {
  setResultados(dados.resultados);
  
}

  setObraSelecionada({
    id: dados.obraId,
    nome: dados.obra
  });

  if (dados.padraoEquipamentoId) {
    setEquipamentoPadraoSelecionado({
      id: dados.padraoEquipamentoId,
      nome: dados.identificacaoPadrao || dados.padraoEquipamentoNome || ""
    });
  }
}
function handleKeyDown(e, rowIndex, field) {

  if (e.key === "Enter") {
    e.preventDefault();

    const proximaLinha = rowIndex + 1;

    const proximoCampo = document.querySelector(
      `[data-row="${proximaLinha}"][data-field="${field}"]`
    );

    if (proximoCampo) {
      proximoCampo.focus();
    }
  }

}

async function carregarObras() {

  const q = query(
    collection(db, "obras"),
    where("ativo", "==", true),
    orderBy("nome")
  );

  const snapshot = await getDocs(consultaTenantAtual(q));

  const lista = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));

  setObras(lista);
}

function normalizarDataISO(valor) {
  if (!valor) return "";

  if (typeof valor === "string") {
    if (/^\d{4}-\d{2}-\d{2}/.test(valor)) {
      return valor.slice(0, 10);
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
      const [dia, mes, ano] = valor.split("/");
      return `${ano}-${mes}-${dia}`;
    }
  }

  if (valor?.toDate) {
    const data = valor.toDate();
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const dia = String(data.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
  }

  if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
    const ano = valor.getFullYear();
    const mes = String(valor.getMonth() + 1).padStart(2, "0");
    const dia = String(valor.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
  }

  return "";
}

function calcularDataVencimentoISO(dataCalibracao, validade) {
  const dataBase = normalizarDataISO(dataCalibracao);
  const textoValidade = String(validade || "").trim().toLowerCase().replace(",", ".");

  if (!dataBase || !textoValidade) {
    return "";
  }

  const quantidade = Number(textoValidade.match(/[\d.]+/)?.[0]);

  if (!Number.isFinite(quantidade) || quantidade <= 0) {
    return "";
  }

  const [ano, mes, dia] = dataBase.split("-").map(Number);
  const vencimento = new Date(ano, mes - 1, dia);

  if (textoValidade.includes("mes")) {
    vencimento.setMonth(vencimento.getMonth() + quantidade);
  } else {
    vencimento.setFullYear(vencimento.getFullYear() + quantidade);
  }

  const anoVencimento = vencimento.getFullYear();
  const mesVencimento = String(vencimento.getMonth() + 1).padStart(2, "0");
  const diaVencimento = String(vencimento.getDate()).padStart(2, "0");

  return `${anoVencimento}-${mesVencimento}-${diaVencimento}`;
}

function calcularValidadePadrao(dataReferencia, dataVencimento) {
  const inicio = normalizarDataISO(dataReferencia);
  const fim = normalizarDataISO(dataVencimento);

  if (!inicio || !fim) {
    return "";
  }

  const [anoInicio, mesInicio] = inicio.split("-").map(Number);
  const [anoFim, mesFim] = fim.split("-").map(Number);
  const meses = (anoFim - anoInicio) * 12 + (mesFim - mesInicio);

  if (meses > 0) {
    return `${meses} meses`;
  }

  return "";
}

function montarEscalaCalibracao(capacidade) {
  const texto = String(capacidade || "").trim();

  if (!texto) {
    return "";
  }

  const numeroCapacidade = Number(
    texto
      .replace(/[^\d,.-]/g, "")
      .replace(/\.(?=\d{3}(?:\D|$))/g, "")
      .replace(",", ".")
  );

  if (!Number.isFinite(numeroCapacidade)) {
    return "";
  }

  const capacidadeKgf = numeroCapacidade * 1000;

  return `0 a ${String(capacidadeKgf).replace(/\.0+$/, "")} kgf`;
}

function formatarDataPadraoExibicao(valor) {
  const dataISO = normalizarDataISO(valor);

  if (!dataISO) {
    return "";
  }

  const [ano, mes, dia] = dataISO.split("-");
  return `${dia}/${mes}/${ano}`;
}

function extrairDadosDescricaoPadrao(texto) {
  const descricao = String(texto || "").trim();
  if (!descricao) {
    return {
      identificacao: "",
      laboratorio: ""
    };
  }

  const matchLaboratorio = descricao.match(/laborat[oó]rio/i);

  if (matchLaboratorio?.index === undefined) {
    return {
      identificacao: descricao,
      laboratorio: ""
    };
  }

  const laboratorioSemPrefixo = descricao
    .slice(matchLaboratorio.index)
    .replace(/^laborat[oó]rio\s*[:\-]?\s*/i, "")
    .trim();

  return {
    identificacao: descricao.slice(0, matchLaboratorio.index).trim().replace(/[,:;/-]+$/, "").trim(),
    laboratorio: laboratorioSemPrefixo
  };
}

function obterNumeroCertificadoPadrao(equipamento, certificadoAtivo) {
  return (
    equipamento?.numeroCertificadoPadrao ||
    equipamento?.numeroCertificado ||
    equipamento?.certificadoPadrao ||
    equipamento?.certificado?.numeroCertificado ||
    equipamento?.certificado?.numero ||
    certificadoAtivo?.numeroCertificado ||
    certificadoAtivo?.numero ||
    certificadoAtivo?.certificado ||
    ""
  );
}

function obterPrioridadeDocumentoPadrao(documento) {
  const statusAtivo = documento?.statusDocumento === "ENVIADO" ? 1 : 0;
  const possuiNumeroCertificado = String(
    documento?.numeroCertificado || documento?.numero || documento?.certificado || ""
  ).trim()
    ? 1
    : 0;
  const possuiDatasCalibracao =
    normalizarDataISO(documento?.dataReferencia) && normalizarDataISO(documento?.dataVencimento)
      ? 1
      : 0;
  const tipoPrioritario =
    documento?.tipoDocumentoCodigo === "CELULA_DE_CARGA"
      ? 2
      : documento?.tipoDocumentoCodigo === "CERTIFICADO"
        ? 1
        : 0;

  return `${statusAtivo}${possuiNumeroCertificado}${possuiDatasCalibracao}${tipoPrioritario}`;
}

async function carregarEquipamentosPadrao() {
  const [equipSnap, docsSnap] = await Promise.all([
    getDocs(consultaTenantAtual(query(collection(db, "equipamentos"), orderBy("nome")))),
    getDocs(consultaTenantAtual(collection(db, "eq_documentos")))
  ]);

  const certificadosPorEquipamento = {};

  docsSnap.docs.forEach((item) => {
    const documento = item.data();

    if (!documento.equipamentoId) {
      return;
    }

    const numeroCertificado = String(
      documento.numeroCertificado || documento.numero || documento.certificado || ""
    ).trim();

    if (!numeroCertificado) {
      return;
    }

    const atual = certificadosPorEquipamento[documento.equipamentoId];
    const prioridadeAtual = obterPrioridadeDocumentoPadrao(atual);
    const prioridadeNova = obterPrioridadeDocumentoPadrao(documento);
    const dataAtual = normalizarDataISO(atual?.dataReferencia || atual?.updatedAt || atual?.createdAt);
    const dataNova = normalizarDataISO(
      documento.dataReferencia || documento.updatedAt || documento.createdAt
    );

    if (
      !atual ||
      prioridadeNova > prioridadeAtual ||
      (prioridadeNova === prioridadeAtual && dataNova >= dataAtual)
    ) {
      certificadosPorEquipamento[documento.equipamentoId] = documento;
    }
  });

  const lista = equipSnap.docs
    .map((item) => {
      const equipamento = { id: item.id, ...item.data() };
      const certificadoAtivo = certificadosPorEquipamento[equipamento.id] || null;

      return {
        ...equipamento,
        certificadoAtivo
      };
    })
    .filter((equipamento) => equipamento.ativo !== false);

  setEquipamentosPadrao(lista);
}

function aplicarEquipamentoPadrao(equipamento) {
  setEquipamentoPadraoSelecionado(equipamento);

  if (!equipamento) {
    setForm((anterior) => ({
      ...anterior,
      padraoEquipamentoId: "",
      padraoEquipamentoNome: "",
      identificacaoPadrao: "",
      laboratorioPadrao: "",
      certificadoPadrao: "",
      dataPadrao: "",
      validadePadrao: ""
    }));
    return;
  }

  const certificadoAtivo = equipamento?.certificadoAtivo || null;
  const dadosDescricao = extrairDadosDescricaoPadrao(
    equipamento?.descricaoPadrao || equipamento?.descricao || ""
  );
  const dataPadrao = normalizarDataISO(
    equipamento?.dataCalibracaoPadrao ||
      certificadoAtivo?.dataReferencia ||
      certificadoAtivo?.createdAt
  );
  const validadePadrao =
    equipamento?.validadePadrao ||
    calcularValidadePadrao(certificadoAtivo?.dataReferencia, certificadoAtivo?.dataVencimento) ||
    "";
  const numeroCertificadoPadrao = obterNumeroCertificadoPadrao(equipamento, certificadoAtivo);

  setForm((anterior) => ({
    ...anterior,
    padraoEquipamentoId: equipamento?.id || "",
    padraoEquipamentoNome: equipamento?.nome || "",
    identificacaoPadrao:
      equipamento?.identificacaoPadrao ||
      dadosDescricao.identificacao ||
      equipamento?.nome ||
      "",
    laboratorioPadrao:
      equipamento?.laboratorioPadrao ||
      dadosDescricao.laboratorio ||
      certificadoAtivo?.laboratorio ||
      "",
    certificadoPadrao: numeroCertificadoPadrao || "",
    dataPadrao: dataPadrao || "",
    validadePadrao: validadePadrao || ""
  }));
}

const estadoInicial = {
  data: "",
  codigo: "",
  certificado: "",
  dataCalibracao: "",
  dataVencimento: "",
  validade: "",
  classe: "",
usoInterno: false,
  empresa: "",
  obra: "",
  endereco: "",

  equipamento: "",
  capacidade: "",
  escala: "",
  valorDivisao: "0,10",
  padraoEquipamentoId: "",
  padraoEquipamentoNome: "",
  identificacaoPadrao: "",
  laboratorioPadrao: "",
  certificadoPadrao: "",
  dataPadrao: "",
  validadePadrao: "",

  fornecedor: "",
  modelo: "",
  serie: "",
  patrimonio: ""
};

const [form,setForm] = useState(estadoInicial);

useEffect(() => {
  if (!form.padraoEquipamentoId || equipamentosPadrao.length === 0) return;

  const encontrado = equipamentosPadrao.find(
    (item) => item.id === form.padraoEquipamentoId
  );

  if (encontrado) {
    setEquipamentoPadraoSelecionado(encontrado);
  }
}, [form.padraoEquipamentoId, equipamentosPadrao]);

const pontosPadrao = [
  { kgf: 10000,  kn: 98.1 },
  { kgf: 20000,  kn: 196.1 },
  { kgf: 30000,  kn: 294.2 },
  { kgf: 40000,  kn: 392.3 },
  { kgf: 60000,  kn: 588.4 },
  { kgf: 80000,  kn: 784.5 },
  { kgf: 100000, kn: 980.7 },
  { kgf: 120000, kn: 1176.8 }
];
const [resultados,setResultados] = useState(
  pontosPadrao.map(p=>({
    ...p,
    l1:"",
    l2:"",
    l3:"",
    mediaKgf:"",
    mediaKn:"",
    erro:"",
    resolucao:"",
    repet:"",
    classe:""
  }))
);

const [classeGeral, setClasseGeral] = useState("");
const [classeEditadaManualmente, setClasseEditadaManualmente] = useState(false);

function equipamentoEhManual(valor) {
  return String(valor || "").trim().toLowerCase() === "manual";
}

function equipamentoEhEletrico(valor) {
  return String(valor || "").trim().toLowerCase() === "eletrica";
}

function formatarClasseFinal(valor) {
  const numero = Number(valor);
  return Number.isFinite(numero) ? String(Math.trunc(numero)) : "";
}

function calcularClasseFinalEquipamento(tipoEquipamento, resultadosAtuais) {
  if (equipamentoEhManual(tipoEquipamento)) return "2";

  const classesValidas = resultadosAtuais
    .map((r) => {
      if (!r.classe || r.classe === "-") return null;
      return parseFloat(r.classe.replace(",", "."));
    })
    .filter((v) => v !== null);

  if (classesValidas.length === 0) return "";

  const classeSelecionada = equipamentoEhEletrico(tipoEquipamento)
    ? Math.max(...classesValidas)
    : Math.min(...classesValidas);

  return formatarClasseFinal(classeSelecionada);
}


useEffect(() => {
  if (classeEditadaManualmente) return;

  setClasseGeral(
    calcularClasseFinalEquipamento(form.equipamento, resultados)
  );
}, [form.equipamento, resultados, classeEditadaManualmente]);

function extrairNumeroSequencialCodigo(valor) {
  const texto = String(valor || "").trim();
  if (!texto) return null;

  const grupos = texto.match(/\d+/g);
  if (!grupos?.length) return null;

  const maiorGrupo = grupos.sort((a, b) => b.length - a.length)[0];
  const numero = Number(maiorGrupo);

  return Number.isFinite(numero) ? numero : null;
}

function formatarCodigoCalibracao(numero, ano) {
  return `RE-CAL - ${String(Number(numero) || 0).padStart(4, "0")}/${ano}`;
}

async function obterProximoCodigoCalibracao() {
  const anoAtual = new Date().getFullYear();
  const snap = await getDocs(consultaTenantAtual(collection(db, "tblCalibracaoPrensas")));

  let maiorSequencial = 0;

  snap.docs.forEach((item) => {
    const dados = item.data();
    const dataBase = String(dados.dataCalibracao || dados.data || "");
    const anoRegistro = /^\d{4}/.test(dataBase) ? Number(dataBase.slice(0, 4)) : null;

    if (anoRegistro && anoRegistro !== anoAtual) return;

    const sequencial = extrairNumeroSequencialCodigo(dados.codigo);
    if (sequencial && sequencial > maiorSequencial) {
      maiorSequencial = sequencial;
    }
  });

  const proximoSequencial = maiorSequencial + 1;

  return {
    sequencial: proximoSequencial,
    anoAtual,
    codigoFormatado: formatarCodigoCalibracao(proximoSequencial, anoAtual)
  };
}

function atualizar(index,campo,valor){

  const lista=[...resultados];
  lista[index][campo]=valor;

  // 🔥 se alterar o kgf → recalcula kN automaticamente
if (campo === "kgf") {
  const kgf = parseFloat(String(valor).replace(",", "."));

  if (!isNaN(kgf)) {
    lista[index].kn = (kgf * 0.0098065).toFixed(1);
  } else {
    lista[index].kn = "";
  }
}

  const v1 = lista[index].l1;
const v2 = lista[index].l2;
const v3 = lista[index].l3;

// 🚨 NOVA REGRA: se tiver "-" ou vazio → ignora tudo
if (
  v1 === "-" || v2 === "-" || v3 === "-" ||
  v1 === "" || v2 === "" || v3 === ""
) {
  lista[index].mediaKgf = "-";
  lista[index].mediaKn = "-";
  lista[index].erro = "-";
  lista[index].resolucao = "-";
  lista[index].repet = "-";
  lista[index].classe = "-";

  setResultados(lista);
  return;
}

// só converte depois da validação
const a = parseFloat(v1);
const b = parseFloat(v2);
const c = parseFloat(v3);

if (!isNaN(a) && !isNaN(b) && !isNaN(c)) {
    const media = (a + b + c) / 3;

// média em kgf
lista[index].mediaKgf = media.toFixed(0);

// média em kN (usando 0,0098065)
const mediaKn = media * 0.0098065;
lista[index].mediaKn = mediaKn.toFixed(2);

// 👇 GARANTE número real
const mediaKnNum = mediaKn;

    const erro=((media-lista[index].kgf)/lista[index].kgf)*100;
    lista[index].erro=erro.toFixed(2);

  const divisao = parseFloat(
  String(form.valorDivisao).replace(",", ".")
);

if (!isNaN(divisao) && mediaKnNum !== 0) {

  const resolucao = (divisao / mediaKnNum) * 100;
lista[index].resolucao = resolucao.toFixed(2);
const max = Math.max(a, b, c);
const min = Math.min(a, b, c);
const repet = ((max - min) / media) * 100;

lista[index].repet = repet.toFixed(2);

const erroAbs = Math.abs(erro);
const resolucaoNum = parseFloat(lista[index].resolucao);

// transforma em 0 ou 1 (igual Excel)
const c05 = [
  erroAbs <= 0.5 ? 1 : 0,
  repet <= 0.5 ? 1 : 0,
  resolucaoNum <= 0.25 ? 1 : 0,
  1 // (no Excel sempre tem 4 colunas)
];

const c1 = [
  erroAbs <= 1 ? 1 : 0,
  repet <= 1 ? 1 : 0,
  resolucaoNum <= 0.5 ? 1 : 0,
  1
];

const c2 = [
  erroAbs <= 2 ? 1 : 0,
  repet <= 2 ? 1 : 0,
  resolucaoNum <= 1 ? 1 : 0,
  1
];

const c3 = [
  erroAbs <= 3 ? 1 : 0,
  repet <= 3 ? 1 : 0,
  resolucaoNum <= 1.5 ? 1 : 0,
  1
];

// soma igual Excel
const soma = arr => arr.reduce((t, v) => t + v, 0);

let classe = "-";

if (soma(c05) === 4) classe = "0,5";
else if (soma(c1) === 4) classe = "1,0";
else if (soma(c2) === 4) classe = "2,0";
else if (soma(c3) === 4) classe = "3,0";

lista[index].classe = classe;

}
  }

  setResultados(lista);
}
function imprimir() {

  const conteudo = document.getElementById("area-impressao");
  if (!conteudo) return;

  abrirJanelaImpressao({
    title: "Certificado de Calibracao de Prensa",
    html: conteudo.innerHTML,
    printStyles: "@page { size: A4 portrait; margin: 5mm; }"
  });
}


async function salvar(){

  try{
    const dataVencimento = calcularDataVencimentoISO(
      form.dataCalibracao || form.data,
      form.validade
    );

    let dadosParaSalvar = {
  ...form,
  usoInterno: !!form.usoInterno,
  dataVencimento,
  escala: form.escala || montarEscalaCalibracao(form.capacidade),
  classe: classeGeral,
  classeEditadaManualmente,
  resultados
};

    if (id && id !== "novo") {
      // 🔥 MODO EDIÇÃO
      await updateDoc(
        doc(db,"tblCalibracaoPrensas",id),
        dadosParaSalvar
      );

    } else {
      const codigoAtual = String(form.codigo || "").trim();
      const codigoFormatadoValido = /^RE-CAL\s*-\s*\d+\/\d{4}$/i.test(codigoAtual);

      if (!codigoFormatadoValido) {
        const ano = new Date(form.dataCalibracao || form.data || new Date()).getFullYear();
        const legado = await obterProximoCodigoCalibracao();
        const proximoCodigo = await gerarSequencial({
          chave: "calibracao_prensa",
          escopo: ano,
          formato: {
            padding: 4,
            ano,
            template: "RE-CAL - {numero}/{ano}",
          },
          valorMinimo: Number(legado.sequencial || 1) - 1,
        });
        dadosParaSalvar = {
          ...dadosParaSalvar,
          codigo: proximoCodigo.codigo
        };
      }
      // 🔥 MODO NOVO
      await addDoc(
        collection(db,"tblCalibracaoPrensas"),
        aplicarTenantAtual({
          ...dadosParaSalvar,
          criado:new Date()
        })
      );
    }

    history.goBack();

  }catch(e){

    console.log(e);
    alert("Erro ao salvar");

  }

}

function obterClasseGeral() {
  if (equipamentoEhManual(form.equipamento)) return "2";

  const classesValidas = resultados
    .map(r => {
      if (!r.classe || r.classe === "-") return null;
      return parseFloat(r.classe.replace(",", "."));
    })
    .filter(v => v !== null);

  if (classesValidas.length === 0) return "";

  // ✅ AGORA CORRETO → maior valor
  const menor = Math.min(...classesValidas);

  return formatarClasseFinal(menor);
}

const dadosPadraoSelecionado = extrairDadosDescricaoPadrao(
  equipamentoPadraoSelecionado?.descricaoPadrao ||
    equipamentoPadraoSelecionado?.descricao ||
    ""
);

const identificacaoPadraoExibicao =
  form.identificacaoPadrao || dadosPadraoSelecionado.identificacao || "";

const laboratorioPadraoExibicao =
  form.laboratorioPadrao || dadosPadraoSelecionado.laboratorio || "";

const certificadoPadraoExibicao =
  form.certificadoPadrao ||
  obterNumeroCertificadoPadrao(
    equipamentoPadraoSelecionado,
    equipamentoPadraoSelecionado?.certificadoAtivo
  ) ||
  "";

const dataPadraoExibicao = formatarDataPadraoExibicao(form.dataPadrao);

const validadePadraoExibicao = form.validadePadrao || "";
const dataVencimentoExibicao = formatarDataPadraoExibicao(
  form.dataVencimento ||
  calcularDataVencimentoISO(form.dataCalibracao || form.data, form.validade)
);

function CampoSomenteLeitura({ label, value, sx }) {
  return (
    <Box
      sx={{
        minHeight: 56,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        borderBottom: "1px solid",
        borderColor: "divider",
        py: 0.5,
        ...sx
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500, wordBreak: "break-word" }}>
        {value || "-"}
      </Typography>
    </Box>
  );
}


return (

<>
<Navbar />

<Box sx={{ px: 3, pb: 3, pt: "88px" }}>

<Box
  mb={3}
  display="flex"
  alignItems="center"
  justifyContent="space-between"
  gap={3}
  sx={{
    position: "fixed",
    top: 60,
    left: 0,
    right: 0,
    zIndex: 1190,
    bgcolor: "background.paper",
    borderBottom: "1px solid",
    borderColor: "divider",
    px: 3,
    py: 1.5,
    boxShadow: 2
  }}
>

  <Typography variant="h5">
    Cadastro de Calibração de Prensa
  </Typography>

  <Stack direction="row" spacing={2}>
  <Button
    variant="outlined"
    onClick={() => history.goBack()}
  >
    Voltar
  </Button>

  <Button
    variant="outlined"
    onClick={imprimir}
  >
    Imprimir
  </Button>

  <Button
    variant="contained"
    onClick={() => executarSalvamento(salvar)}
    disabled={salvandoCadastro}
  >
    {salvandoCadastro ? "Salvando..." : "Salvar"}
  </Button>
  </Stack>

</Box>

<Paper sx={{p:2,mb:3}}>

<Stack spacing={2}>   {/* STACK PRINCIPAL */}

  <Stack direction="row" spacing={2} alignItems="center">

  {/* ESQUERDA */}
  <TextField
    label="Código"
    value={form.codigo}
    onChange={e => setForm({ ...form, codigo: e.target.value })}
    sx={{ width: "120px" }}
  />

  <CampoSomenteLeitura label="Cliente" value={form.empresa} sx={{ flex: 1 }} />

  {/* DIREITA */}
  <Stack direction="row" spacing={2} sx={{ marginLeft: "auto" }}>

    <TextField
      type="date"
      label="Data de calibração"
      value={form.dataCalibracao}
      onChange={e => setForm({ ...form, dataCalibracao: e.target.value })}
      InputLabelProps={{ shrink: true }}
      sx={{ width: "170px" }}
    />

    <TextField
      label="Validade (anos)"
      value={form.validade}
      onChange={e => setForm({ ...form, validade: e.target.value })}
      sx={{ width: "130px" }}
    />

    <CampoSomenteLeitura
      label="Data de vencimento"
      value={dataVencimentoExibicao}
      sx={{ width: "170px" }}
    />

  </Stack>

</Stack>

<Stack direction="row" spacing={2} alignItems="center">

  <Autocomplete
    sx={{ flex: 1.2 }}
    options={equipamentosPadrao}
    getOptionLabel={(option) => option?.nome || ""}
    value={equipamentoPadraoSelecionado}
    onChange={(event, newValue) => {
      aplicarEquipamentoPadrao(newValue);
    }}
    inputValue={pesquisaEquipamentoPadrao}
    onInputChange={(event, newInputValue) => {
      setPesquisaEquipamentoPadrao(newInputValue);
    }}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Máquina padrão utilizada"
        placeholder="Selecionar célula de carga padrão"
      />
    )}
  />

  <CampoSomenteLeitura
    label="Identificação"
    value={identificacaoPadraoExibicao}
    sx={{ flex: 1 }}
  />

  <CampoSomenteLeitura
    label="Laboratório"
    value={laboratorioPadraoExibicao}
    sx={{ flex: 1 }}
  />

  <CampoSomenteLeitura
    label="Certificado"
    value={certificadoPadraoExibicao}
    sx={{ width: "180px" }}
  />

  <CampoSomenteLeitura
    label="Data de calibração"
    value={dataPadraoExibicao}
    sx={{ width: "150px" }}
  />

  <CampoSomenteLeitura
    label="Validade"
    value={validadePadraoExibicao}
    sx={{ width: "120px" }}
  />

</Stack>

<Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="stretch">

  <Autocomplete
    fullWidth
    sx={{ flex: 1, minWidth: { md: 360 } }}
    options={obras}
    getOptionLabel={(option) => option.nome || ""}
    value={obraSelecionada}
    onChange={(event, newValue) => {

      setObraSelecionada(newValue);

      setForm({
        ...form,
        obra: newValue?.nome || "",
        obraId: newValue?.id || "",
        empresa: newValue?.clienteNome || "",
        endereco: newValue?.endereco || ""
      });

    }}
    inputValue={pesquisaObra}
    onInputChange={(event, newInputValue) => {
      setPesquisaObra(newInputValue);
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Empreendimento"
        placeholder="Pesquisar obra..."
      />
    )}
  />

  <CampoSomenteLeitura label="Endereço" value={form.endereco} sx={{ flex: 1, minWidth: { md: 320 } }} />

</Stack>

<Stack direction="row" spacing={2} alignItems="center">

  {/* EQUIPAMENTO */}
  <Stack spacing={0.5} sx={{ minWidth: "320px" }}>

    <strong>Equipamento:</strong>

    <RadioGroup
      row
      value={form.equipamento}
      onChange={(e) => setForm({ ...form, equipamento: e.target.value })}
    >
      <FormControlLabel value="Eletrica" control={<Radio />} label="ELÉTRICA" />
      <FormControlLabel value="Manual" control={<Radio />} label="MANUAL" />
    </RadioGroup>

  </Stack>

  <TextField
    label="Capacidade (tf)"
    value={form.capacidade}
    onChange={e =>
      setForm({
        ...form,
        capacidade: e.target.value,
        escala: montarEscalaCalibracao(e.target.value)
      })
    }
    sx={{ width: "120px" }}
  />

  <CampoSomenteLeitura
    label="Escala calibração"
    value={form.escala}
    sx={{ width: "170px" }}
  />

  {/* VALOR DIVISÃO */}
  <TextField
    label="Valor de divisão (kN)"
    value={form.valorDivisao}
    onChange={e => {
      const valor = parseFloat(e.target.value.replace(",", "."));

      setForm({ ...form, valorDivisao: e.target.value });
      recalcularResultados(valor);
    }}
    sx={{ width: "150px" }}
  />

  <TextField
    label="Fornecedor"
    value={form.fornecedor}
    onChange={e => setForm({ ...form, fornecedor: e.target.value })}
    sx={{ width: "240px" }}
  />

  <TextField
    label="Modelo / Número"
    value={form.modelo}
    onChange={e => setForm({ ...form, modelo: e.target.value })}
    sx={{ width: "160px" }}
  />
  <Stack direction="row" spacing={2} alignItems="center">
    <TextField
      label="Série"
      value={form.serie}
      onChange={e => setForm({ ...form, serie: e.target.value })}
      sx={{ width: "140px" }}
    />

    <TextField
      label="Classe"
      value={classeGeral}
      onChange={(e) => {
        setClasseEditadaManualmente(true);
        setClasseGeral(e.target.value);
      }}
      sx={{ width: "90px" }}
    />

    <FormControlLabel
      control={
        <Checkbox
          checked={!!form.usoInterno}
          onChange={(e) =>
            setForm({
              ...form,
              usoInterno: e.target.checked
            })
          }
        />
      }
      label="Uso interno"
    />
  </Stack>
</Stack>

</Stack>

</Paper>

<Paper sx={{p:2}}>

<Table
  sx={{
    "& .MuiTableCell-root": {
      fontSize: "1rem"
    },
    "& .MuiInputBase-input": {
      fontSize: "1rem",
      fontWeight: 500
    }
  }}
>

<TableHead>

  {/* TÍTULO */}
  <TableRow>
    <TableCell colSpan={11} align="center" sx={{ fontWeight: "bold" }}>
      COMPRESSÃO - Valores em kN
    </TableCell>
  </TableRow>

  {/* LINHA PRINCIPAL */}
  <TableRow>

    <TableCell colSpan={2} align="center">
      Força lida no item
    </TableCell>

    <TableCell colSpan={3} align="center">
      Séries de leituras no padrão
    </TableCell>

    <TableCell colSpan={2} align="center">
      Média
    </TableCell>

    <TableCell rowSpan={2} align="center">
      Erro Relativo de Indicação %
    </TableCell>

    <TableCell rowSpan={2} align="center">
      Resolução Relativa
    </TableCell>

    <TableCell rowSpan={2} align="center">
      Erro Relativo de repetitividade %
    </TableCell>

    <TableCell rowSpan={2} align="center">
      Classe
    </TableCell>

  </TableRow>

  {/* SUBLINHA */}
  <TableRow>

    <TableCell align="center">kgf</TableCell>
    <TableCell align="center">kN</TableCell>

    <TableCell align="center">1ª</TableCell>
    <TableCell align="center">2ª</TableCell>
    <TableCell align="center">3ª</TableCell>

    <TableCell align="center">kgf</TableCell>
    <TableCell align="center">kN</TableCell>

  </TableRow>

</TableHead>

<TableBody>

{resultados.map((r,i)=>(

<TableRow key={i}>

<TableCell>
  <TextField
    size="small"
    value={r.kgf}
    onChange={(e) => atualizar(i, "kgf", e.target.value)}
    inputProps={{
      style: { textAlign: "center", fontSize: "1rem" }
    }}
  />
</TableCell>
<TableCell align="center">{r.kn}</TableCell>

<TableCell>

<TextField
  size="small"
  value={r.l1}
  onChange={e=>atualizar(i,"l1",e.target.value)}
  
  inputProps={{
    "data-row": i,
    "data-field": "l1",
    style: { textAlign: "center", fontSize: "1rem" }
  }}
  onKeyDown={(e) => handleKeyDown(e, i, "l1")}
/>

</TableCell>

<TableCell>

<TextField
  size="small"
  value={r.l2}
  onChange={e=>atualizar(i,"l2",e.target.value)}
  inputProps={{
    "data-row": i,
    "data-field": "l2",
    style: { textAlign: "center", fontSize: "1rem" }
  }}
  onKeyDown={(e) => handleKeyDown(e, i, "l2")}
/>

</TableCell>

<TableCell>

<TextField
  size="small"
  value={r.l3}
  onChange={e=>atualizar(i,"l3",e.target.value)}
  inputProps={{
    "data-row": i,
    "data-field": "l3",
    style: { textAlign: "center", fontSize: "1rem" }
  }}
  onKeyDown={(e) => handleKeyDown(e, i, "l3")}
/>

</TableCell>

<TableCell align="center">{r.mediaKgf}</TableCell>
<TableCell align="center">{r.mediaKn}</TableCell>

<TableCell align="center">{r.erro}</TableCell>

<TableCell align="center">{r.resolucao}</TableCell>

<TableCell align="center">{r.repet}</TableCell>

<TableCell align="center">{r.classe}</TableCell>

</TableRow>

))}

</TableBody>

</Table>

</Paper>

</Box>
<div style={{ display: "none" }}>
  <div id="area-impressao">
    <RelatorioCalibracaoPrensaPrint dados={{ ...form, classe: classeGeral, resultados }} />
  </div>
</div>

</>


);

}

